import React from 'react';

/**
 * VEC Fleet Loading Component
 *
 * @param {number} size - Tamaño del icono en px (default: 80)
 * @param {string} variant - Tipo de animación: "breathing", "pulse", "smooth" (default: "breathing")
 * @param {string} text - Texto opcional para mostrar
 * @param {boolean} showText - Mostrar texto debajo del icono (default: false)
 */
export const VECLoader = ({
    size = 80,
    variant = "breathing",
    text = "",
    showText = false
}) => {
    const variantClass = `vec-loader-${variant}`;

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '12px'
        }}>
            <style>{`
                @keyframes vec-loader-breathing {
                    0%   { opacity: 0.7; transform: scale(1);    filter: brightness(1.1) drop-shadow(0 0 15px rgba(168, 85, 247, 0.5)); }
                    25%  { opacity: 1;   transform: scale(1.04); filter: brightness(1.1) drop-shadow(0 0 30px rgba(168, 85, 247, 0.5)); }
                    50%  { opacity: 0.7; transform: scale(1);    filter: brightness(1.1) drop-shadow(0 0 15px rgba(168, 85, 247, 0.5)); }
                    75%  { opacity: 0.4; transform: scale(0.96); filter: brightness(1.1) drop-shadow(0 0 0px  rgba(168, 85, 247, 0.5)); }
                    100% { opacity: 0.7; transform: scale(1);    filter: brightness(1.1) drop-shadow(0 0 15px rgba(168, 85, 247, 0.5)); }
                }
                @keyframes vec-loader-pulse {
                    0%, 40%, 60%, 100% { opacity: 0.7; transform: scale(1);    filter: brightness(1.1) drop-shadow(0 0 12px rgba(168, 85, 247, 0.5)); }
                    45%, 55%           { opacity: 1;   transform: scale(1.08); filter: brightness(1.1) drop-shadow(0 0 35px rgba(168, 85, 247, 0.5)); }
                }
                @keyframes vec-loader-smooth {
                    0%   { opacity: 0.85; transform: scale(1);    filter: brightness(1.1) drop-shadow(0 0 18px rgba(168, 85, 247, 0.5)); }
                    25%  { opacity: 1;    transform: scale(1.03); filter: brightness(1.1) drop-shadow(0 0 30px rgba(168, 85, 247, 0.5)); }
                    50%  { opacity: 0.85; transform: scale(1);    filter: brightness(1.1) drop-shadow(0 0 18px rgba(168, 85, 247, 0.5)); }
                    75%  { opacity: 0.7;  transform: scale(0.97); filter: brightness(1.1) drop-shadow(0 0 6px  rgba(168, 85, 247, 0.5)); }
                    100% { opacity: 0.85; transform: scale(1);    filter: brightness(1.1) drop-shadow(0 0 18px rgba(168, 85, 247, 0.5)); }
                }
                .vec-loader-breathing { animation: vec-loader-breathing 2s ease-in-out infinite; }
                .vec-loader-pulse     { animation: vec-loader-pulse 1s ease-in-out infinite; }
                .vec-loader-smooth    { animation: vec-loader-smooth 2s ease-in-out infinite; }
            `}</style>
            <img
                src="/assets/vec-icon.png"
                alt="Loading..."
                width={size}
                height={size}
                className={variantClass}
            />
            {showText && text && (
                <div style={{
                    color: '#666',
                    fontSize: '14px',
                    fontWeight: 500
                }}>
                    {text}
                </div>
            )}
        </div>
    );
};

export default VECLoader;
